var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["ispforum.keyword"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "dsKey"
                          }
                        },
                        [
                          this.readonly == "1"
                            ? _c("a-input", {
                                attrs: {
                                  placeholder:
                                    this.language["basedata.pleaseEnter"] +
                                    this.language["ispforum.keyword"]
                                },
                                model: {
                                  value: _vm.model.dsKey,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "dsKey", $$v)
                                  },
                                  expression: "model.dsKey"
                                }
                              })
                            : _vm._e(),
                          this.readonly == "2"
                            ? _c("a-input", {
                                attrs: {
                                  placeholder:
                                    this.language["basedata.pleaseEnter"] +
                                    this.language["ispforum.keyword"],
                                  readOnly: ""
                                },
                                model: {
                                  value: _vm.model.dsKey,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "dsKey", $$v)
                                  },
                                  expression: "model.dsKey"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["datasource.type"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "dataSourceType"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: { type: "list", dictCode: "db_type_sync" },
                            model: {
                              value: _vm.model.dataSourceType,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "dataSourceType", $$v)
                              },
                              expression: "model.dataSourceType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["datasource.url"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "url"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                this.language["basedata.pleaseEnter"] +
                                this.language["datasource.url"]
                            },
                            model: {
                              value: _vm.model.url,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "url", $$v)
                              },
                              expression: "model.url"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["system.user.name"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "username"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                this.language["basedata.pleaseEnter"] +
                                this.language["system.user.name"]
                            },
                            model: {
                              value: _vm.model.username,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "username", $$v)
                              },
                              expression: "model.username"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["column.password"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "password"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                this.language["basedata.pleaseEnter"] +
                                this.language["column.password"]
                            },
                            model: {
                              value: _vm.model.password,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "password", $$v)
                              },
                              expression: "model.password"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["fd.status"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "state"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "radio",
                              dictCode: "datasource_status"
                            },
                            model: {
                              value: _vm.model.state,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "state", $$v)
                              },
                              expression: "model.state"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["dataSource.need.tables"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "needTables"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: this.language[
                                "dataSource.need.tables.desc"
                              ]
                            },
                            model: {
                              value: _vm.model.needTables,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "needTables", $$v)
                              },
                              expression: "model.needTables"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }